import React, { Component, Fragment } from 'react'
import Slider from 'react-slick'
import { translate } from 'react-i18next'

import SliderArrow from '../../Global/SliderArrow'
import DelayLink from '../../Global/DelayLink'
import Icon from '../../Global/Icon'
import scrollIt from '../../../utils/scrollIt';

class StepNav extends Component {
  render() {
    const {
      currentStep,
      t,
      toggleMap,
      trip: {
        slug,
        acf: {
          steps
        }
      },
    } = this.props
    const sliderSettings = {
      infinite: false,
      initialSlide: Math.floor((currentStep - 1) / 5) * 5,
      prevArrow: <SliderArrow to="prev" />,
      nextArrow: <SliderArrow to="next" />,
      slidesToScroll: 5,
      slidesToShow: 5,
      vertical: true,
    }

    return (
      <div className="trip__nav">
        <DelayLink
          to={{pathname: '/', state: { to: 'home'}}}
          delay={700}
          className="trip__back button button--text"
          onClick={() => scrollIt(0, 700, 'easeInOutQuint')}
        >
          <Fragment>
            <Icon className="icon icon-prev" icon="prev" />
            <span>{ t('step-nav.back') }</span>
          </Fragment>
        </DelayLink>
        {steps.length > 1 &&
          <Slider {...sliderSettings} className={`items ${steps.length <= 5 && 'items--heightfix'}`}>
            {steps.map((step, index) => (
              <div key={`step-${index}`}>
                <div
                  className={`item ${(index + 1) === currentStep ? 'item--current' : ''}`}
                  onClick={e => {
                    e.currentTarget.closest('.items').querySelectorAll('.item').forEach(item => item.classList.remove('item--current'))
                    e.currentTarget.classList.add('item--current')
                    scrollIt(0, 700, 'easeInOutQuint')
                  }}
                >
                  <DelayLink
                    to={{pathname: `/${slug}/${index + 1}`, state: { to: 'trip'}}}
                    delay={700}
                    className="item__link"
                  >
                    {index + 1}
                  </DelayLink>
                </div>
              </div>
            ))}
          </Slider>
        }
        {steps.length > 0 && steps[currentStep - 1].step_img && (
          <button type="button" className="trip__nav-map button button--icon button--circle" onClick={() => toggleMap()}>
            <Icon className="icon icon-pin" icon="pin" />
          </button>
        )}
      </div>
    )
  }
}

export default translate('common')(StepNav)


// WEBPACK FOOTER //
// ./src/components/Step/StepNav/StepNav.js